<info-modal [title]="title" (onOk)="ok()">
	<table class="table">
		<thead>
			<tr>
				<th>
					Дата
				</th>
				
				<th>
					supportName
				</th>
				
				<th>
					{{ type == 'site' ? 'Site' : 'Username' }}
				</th>
				
				<th>
					Действие
				</th>
				
				<th>
					Опции
				</th>
			</tr>
		</thead>
		<tbody>
			<tr *ngFor="let stat of stats" [id]="stat._id">
				<td>
					{{  stat.date }}
				</td>
				
				<td>
					<div style="max-width: 200px;">
						{{ stat.supportName }}
					</div>
					<br/>
					
					<div
						style="max-width: 200px;"
						*ngIf="stat.supportName !== stat.supportEmail"
					>
						{{ stat.supportEmail }}
					</div>
				</td>
				
				<td>
					{{ (type == 'site' ? stat.siteUrl : (stat.userName == stat.userEmail ? stat.userName : stat.userName + '*' + stat.userEmail)) }}
				</td>
				
				<td>
					{{ 'adminstat.support.support.' + stat.action | translate }} ({{ stat.action }})
				</td>
				
				<td>
					<table class="table">
						<tr *ngFor="let opt of stat.opts | keys">
							<td>
								{{opt}}
							</td>
							
							<td>
								<ng-template [ngIf]="opt!=='paymentType'">
									{{stat.opts[opt]}}
								</ng-template>
								
								<ng-template [ngIf]="opt==='paymentType'">
									{{ paymentTypeMap[stat.opts[opt]] }} ({{stat.opts[opt]}})
								</ng-template>
							</td>
						</tr>
					</table>
				</td>
			</tr>
		</tbody>
	</table>
</info-modal>
